/* Orrery — assembling a reading from the library and the chart. One function,
   used by the page (assets/orrery.js renders its output) and by the coverage
   test (tests/reading-coverage.mjs composes every combination and looks for
   placeholders). Loaded after orrery-engine.js, orrery-facts.js and
   orrery-readings.js; no modules.

   compose(chart, tier, library) → paragraphs; a paragraph is a list of
   segments { text, ph } where ph marks an entry that is not yet written.
   rowReading(chart, body, library) → the segments for one placement row. */
(function () {
  var ENGINE = window.OrreryEngine, FACTS = window.OrreryFacts;
  var BODY_KEY = { 'north node': 'northNode', 'south node': 'southNode' };
  var bodyKey = function (b) { return BODY_KEY[b.key] || b.key; };

  // an entry by dotted path, filled, or a placeholder naming it
  function entry(lib, path, words, facts, own) {
    var text = path.split('.').reduce(function (o, k) { return o && o[k] != null ? o[k] : null; }, lib);
    if (typeof text === 'string' && text.trim()) return { text: FACTS.fill(text.trim(), facts, own), ph: false };
    return { text: '[' + path + ' · ' + words + ' words]', ph: true };
  }
  // a sign-and-house module: one paragraph on the page, two in the full reading
  function signHouse(lib, chart, facts, body, b, tier, tail) {
    var own = FACTS.localFields(chart, b.lon);
    var s = 'sign.' + FACTS.signOf(b.lon), h = 'house.' + ENGINE.houseOf(chart.cusps, b.lon);
    var sp = entry(lib, body + '.' + s + '.page', '55–65', facts, own);
    // solar houses put the Sun in the first house by construction: nothing to read there, so the Sun's house paragraph is left out
    if (chart.solarHouses && body === 'sun') return tier === 'page' ? [[sp].concat(tail || [])] : [[sp, entry(lib, body + '.' + s + '.more', '50–60', facts, own)].concat(tail || [])];
    var hp = entry(lib, body + '.' + h + '.page', '45–55', facts, own);
    if (tier === 'page') return [[sp, hp].concat(tail || [])];
    return [[sp, entry(lib, body + '.' + s + '.more', '50–60', facts, own)], [hp, entry(lib, body + '.' + h + '.more', '40–50', facts, own)].concat(tail || [])];
  }
  /* tier 'page': Sun, Moon (with its phase), rising, blend.
     tier 'full': the same with their `more` halves, then the chart ruler, the
     kind of the tightest aspect (the pair and orb arrive through {tightest}),
     and a close that knows whether anything is retrograde. */
  function compose(chart, tier, lib) {
    var facts = FACTS.factsFor(chart, lib);
    var risingOwn = FACTS.localFields(chart, chart.asc);
    var phase = [entry(lib, 'phase.' + chart.lunarPhase.name, '20–30', facts, FACTS.localFields(chart, facts.moon.lon))];
    var rising = facts.rising ? [entry(lib, 'rising.' + facts.rising + '.page', '80–100', facts, risingOwn)] : null;   // none without a birth time
    var blend = [entry(lib, 'blend.' + facts.blendKey + '.page', '70–90', facts, null)];
    if (tier !== 'page') {
      if (rising) rising.push(entry(lib, 'rising.' + facts.rising + '.more', '60–80', facts, risingOwn));
      blend.push(entry(lib, 'blend.' + facts.blendKey + '.more', '50–70', facts, null));
    }
    var paras = signHouse(lib, chart, facts, 'sun', facts.sun, tier).concat(signHouse(lib, chart, facts, 'moon', facts.moon, tier, phase), rising ? [rising] : [], [blend]);
    if (tier === 'page') return paras;
    if (facts.ruler) {
      var own = FACTS.localFields(chart, facts.ruler.lon);
      paras.push([entry(lib, 'ruler.planet.' + bodyKey(facts.ruler), '35–45', facts, own), entry(lib, 'ruler.house.' + facts.rulerHouse, '25–35', facts, own)]);
    }
    if (facts.asp) paras.push([entry(lib, 'aspect.generic.' + facts.asp.type, '50–70', facts, null)]);
    paras.push([entry(lib, 'close.' + (facts.retro.length ? 'retro' : 'none'), '40–60', facts, null)]);
    return paras;
  }
  /* the emails, composed here so the page's console preview, the coverage test and
     the Worker all read the same text. Neither repeats the page (Sun, Moon, rising).
     emailOne: the old email 1 modules (Venus, Mars, the seventh and fifth houses),
     kept for the coverage test; the Worker's email 1 is the full tier and the rows.
     emailTwo / emailTwoSections: love (Venus, Mars, the fifth and seventh houses),
     then the chart ruler (or why there is none), the tightest aspect, the chart
     pattern, the balance of elements and modalities.
     `analysis` is OrreryAnalysis.analyse(chart) (for the patterns); without it the
     pattern module is skipped. */
  var PATTERN_KEY = { 'grand cross': 'grandCross', 'T-square': 'tSquare', 'grand trine': 'grandTrine', 'yod': 'yod', 'stellium': 'stellium' };
  var PATTERN_ORDER = ['grand cross', 'T-square', 'grand trine', 'yod', 'stellium'];   // the rarest first: one pattern per chart
  var listWords = function (names) { return names.length < 2 ? names.join('') : names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1]; };
  var the = function (n) { return n === 'Sun' || n === 'Moon' ? 'the ' + n : n; };
  function chosenPattern(analysis) {
    var found = analysis && analysis.patterns ? analysis.patterns.found : [];
    for (var i = 0; i < PATTERN_ORDER.length; i++) { var hit = found.filter(function (p) { return p.kind === PATTERN_ORDER[i]; })[0]; if (hit) return hit; }
    return null;
  }
  function patternFields(p) {
    if (!p) return {};
    var names = (p.bodies || []).map(function (b) { return the(b.name || b); });
    return { pattern_bodies: listWords(names), Pattern_bodies: listWords(names).replace(/^./, function (c) { return c.toUpperCase(); }),
      pattern_sign: p.sign != null ? ENGINE.SIGN_NAMES[p.sign] : '', pattern_element: p.element ? p.element.toLowerCase() : '',
      pattern_modality: p.modality ? p.modality.toLowerCase() : '', pattern_apex: p.apex ? the(p.apex.name || p.apex) : '' };
  }
  function emailOne(chart, lib) {
    var facts = FACTS.factsFor(chart, lib);
    var byKey = function (k) { return chart.bodies.filter(function (b) { return b.key === k; })[0]; };
    var paras = signHouse(lib, chart, facts, 'venus', byKey('venus'), 'page').concat(signHouse(lib, chart, facts, 'mars', byKey('mars'), 'page'));
    [[7, facts.house7], [5, facts.house5]].forEach(function (pair) {
      var n = pair[0], h = pair[1];
      var own = { sign: h.sign, house_ordinal: FACTS.houseWord(n), House_ordinal: FACTS.houseWord(n).replace(/^./, function (c) { return c.toUpperCase(); }) };
      paras.push([entry(lib, 'house.' + n + '.sign.' + h.sign, '45–65', facts, own), entry(lib, 'house.' + n + '.' + (h.planets.length ? 'occupied' : 'empty'), '25–45', facts, own)]);
    });
    return paras;
  }
  var cap = function (s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; };
  /* email 2 (2026-09-22): love and relationships first, then the chart ruler, the tightest
     aspect, the pattern and the balance, as groups of headed sections so it scrolls on a
     phone. Every entry runs to two short paragraphs ("\n\n" inside an entry breaks the
     paragraph at render). emailTwo() flattens the same sections into paragraphs. */
  function love(chart, lib) {
    var facts = FACTS.factsFor(chart, lib);
    var timed = !chart.solarHouses && !!chart.cusps;   // no birth time: Venus and Mars by sign only, then the invitation
    var byKey = function (k) { return chart.bodies.filter(function (b) { return b.key === k; })[0]; };
    var body = function (name, key) {
      var b = byKey(key), own = FACTS.localFields(chart, b.lon);
      var paras = [[entry(lib, key + '.sign.' + FACTS.signOf(b.lon) + '.page', '55–75', facts, own)]];
      if (timed) paras.push([entry(lib, key + '.house.' + ENGINE.houseOf(chart.cusps, b.lon) + '.page', '45–75', facts, own)]);
      return { heading: name + ' in ' + FACTS.signOf(b.lon), paras: paras };
    };
    var sections = [body('Venus', 'venus'), body('Mars', 'mars')];
    if (!timed) { sections.push({ heading: '', paras: [[entry(lib, 'love.untimed', '40–60', facts, null)]] }); return sections; }
    [[5, facts.house5, 'The fifth house'], [7, facts.house7, 'The seventh house']].forEach(function (t) {
      var n = t[0], h = t[1];
      var own = { sign: h.sign, house_ordinal: FACTS.houseWord(n), House_ordinal: cap(FACTS.houseWord(n)) };
      sections.push({ heading: t[2] + ', in ' + h.sign, paras: [[entry(lib, 'house.' + n + '.sign.' + h.sign, '45–65', facts, own)], [entry(lib, 'house.' + n + '.' + (h.planets.length ? 'occupied' : 'empty'), '25–45', facts, own)]] });
    });
    sections.push({ heading: '', paras: [[entry(lib, 'love.close', '50–80', facts, null)]] });
    return sections;
  }
  function emailTwoSections(chart, lib, analysis) {
    var facts = FACTS.factsFor(chart, lib);
    var groups = [{ title: 'Love and relationships', sections: love(chart, lib) }];
    if (chart.solarHouses || !chart.cusps) groups.push({ title: 'The chart ruler', sections: [{ heading: 'No chart ruler without a birth time', paras: [[entry(lib, 'ruler.untimed', '30–50', facts, null)]] }] });
    else if (facts.ruler) {
      var own = FACTS.localFields(chart, facts.ruler.lon);
      groups.push({ title: 'The chart ruler', sections: [{ heading: the(facts.ruler.name).replace(/^./, function (c) { return c.toUpperCase(); }), paras: [[entry(lib, 'ruler.planet.' + bodyKey(facts.ruler), '90–130', facts, own)], [entry(lib, 'ruler.house.' + facts.rulerHouse, '50–90', facts, own)]] }] });
    }
    if (facts.asp) groups.push({ title: 'The tightest aspect', sections: [{ heading: facts.fields.Aspect_a + ' and ' + facts.fields.aspect_b, paras: [[entry(lib, 'aspect.generic.' + facts.asp.type, '110–170', facts, null)]] }] });
    if (analysis) { var p = chosenPattern(analysis); groups.push({ title: 'The pattern', sections: [{ heading: p ? cap(p.kind) : 'No pattern', paras: [[entry(lib, 'pattern.' + (p ? PATTERN_KEY[p.kind] : 'none'), '110–170', facts, patternFields(p))]] }] }); }
    var b = facts.balance, bal = [];
    if (b.even) bal.push({ heading: 'Even', paras: [[entry(lib, 'balance.even', '80–120', facts, null)]] });
    else {
      var el = [], mo = [];
      if (b.element.dominant) el.push(entry(lib, 'balance.element.' + b.element.dominant, '70–120', facts, null));
      if (b.element.lacking) el.push(entry(lib, 'balance.element.lacking.' + b.element.lacking, '70–120', facts, null));
      if (b.modality.dominant) mo.push(entry(lib, 'balance.modality.' + b.modality.dominant, '70–120', facts, null));
      if (b.modality.lacking) mo.push(entry(lib, 'balance.modality.lacking.' + b.modality.lacking, '70–120', facts, null));
      if (!el.length && !mo.length) bal.push({ heading: 'Even', paras: [[entry(lib, 'balance.even', '80–120', facts, null)]] });
      if (el.length) bal.push({ heading: 'By element', paras: [el] });
      if (mo.length) bal.push({ heading: 'By modality', paras: [mo] });
    }
    groups.push({ title: 'The balance', sections: bal });
    return groups;
  }
  /* ---- what a section of the analysis means for this chart
     The six sections above the reading each explain a concept in general. This
     answers the other half — what that concept says about THIS chart — and it
     answers it only from text that is already written. A section with nothing
     of its own returns null and the page shows no second option for it, which
     is the whole point: there is no half-written interpretation to hide behind.

     `houses` returns null by design, not by omission. The library's house text
     covers the fifth and the seventh only (those belong to the love reading),
     and everything else the houses section could say — your planet, in your
     house — the placement rows directly above already say, free and open. A
     second copy of it under a different heading is not a second reading. */
  var SECTION_KEYS = ['moon', 'angles', 'aspects', 'houses', 'patterns', 'signature'];
  function sectionReading(chart, lib, analysis, key) {
    if (!chart || !chart.bodies) return null;
    var facts = FACTS.factsFor(chart, lib);
    var paras = [];
    if (key === 'moon') {
      if (!chart.moonKnown || !chart.lunarPhase) return null;
      paras.push([entry(lib, 'moonpanel.' + chart.lunarPhase.name, '70–110', facts, FACTS.localFields(chart, facts.moon.lon))]);
    } else if (key === 'angles') {
      // the horizon and the meridian need a birth time; the nodes never do
      if (chart.anglesKnown && !chart.solarHouses) {
        paras.push([entry(lib, 'rows.sign.asc.' + FACTS.signOf(chart.asc), '60–80', facts, FACTS.localFields(chart, chart.asc))]);
        paras.push([entry(lib, 'rows.sign.mc.' + FACTS.signOf(chart.mc), '60–80', facts, FACTS.localFields(chart, chart.mc))]);
      }
      var nn = chart.bodies.filter(function (b) { return b.key === 'northNode'; })[0];
      if (nn) paras.push([entry(lib, 'rows.sign.northNode.' + FACTS.signOf(nn.lon), '60–80', facts, FACTS.localFields(chart, nn.lon))]);
      if (!paras.length) return null;
    } else if (key === 'aspects') {
      if (!facts.asp) return null;
      paras.push([entry(lib, 'aspect.generic.' + facts.asp.type, '110–170', facts, null)]);
    } else if (key === 'patterns') {
      if (!analysis) return null;
      var p = chosenPattern(analysis);
      paras.push([entry(lib, 'pattern.' + (p ? PATTERN_KEY[p.kind] : 'none'), '110–170', facts, patternFields(p))]);
    } else if (key === 'signature') {
      var b2 = facts.balance;
      if (!b2) return null;
      if (b2.even) paras.push([entry(lib, 'balance.even', '80–120', facts, null)]);
      else {
        var el = [];
        if (b2.element.dominant) el.push(entry(lib, 'balance.element.' + b2.element.dominant, '70–120', facts, null));
        if (b2.element.lacking) el.push(entry(lib, 'balance.element.lacking.' + b2.element.lacking, '70–120', facts, null));
        if (b2.modality.dominant) el.push(entry(lib, 'balance.modality.' + b2.modality.dominant, '70–120', facts, null));
        if (b2.modality.lacking) el.push(entry(lib, 'balance.modality.lacking.' + b2.modality.lacking, '70–120', facts, null));
        if (!el.length) paras.push([entry(lib, 'balance.even', '80–120', facts, null)]);
        else paras.push(el);
      }
    } else {
      return null;                                   // houses: see the note above
    }
    // a placeholder is not an interpretation: if any segment is unwritten, the
    // section has nothing to offer and says so by offering nothing
    for (var i = 0; i < paras.length; i++)
      for (var j = 0; j < paras[i].length; j++)
        if (paras[i][j].ph) return null;
    return paras.length ? paras : null;
  }

  function emailTwo(chart, lib, analysis) {
    var paras = [];
    emailTwoSections(chart, lib, analysis).forEach(function (g) { g.sections.forEach(function (s) { s.paras.forEach(function (p) { paras.push(p); }); }); });
    return paras;
  }
  // one row: the body in its sign, then in its house, then retrograde if it is; asc and mc by sign alone
  function rowReading(chart, b, lib) {
    var facts = FACTS.factsFor(chart, lib);
    var own = FACTS.localFields(chart, b.lon);
    if (b.axis) return [entry(lib, 'rows.sign.' + b.axis + '.' + FACTS.signOf(b.lon), '60–80', facts, own)];
    var k = bodyKey(b);
    var segs = [entry(lib, 'rows.sign.' + k + '.' + FACTS.signOf(b.lon), '40–50', facts, own)];
    if (chart.cusps) segs.push(entry(lib, 'rows.house.' + k + '.' + ENGINE.houseOf(chart.cusps, b.lon), '20–30', facts, own));   // no houses without a time and place
    if (b.retro && !b.node) segs.push(entry(lib, 'rows.retro.' + k, '15–25', facts, own));
    return segs;
  }
  // every row of a chart, in the order the page lists them: Sun, Moon, Ascendant, the rest, Midheaven
  function allRows(chart, lib) {
    var rows = [];
    var push = function (label, segs) { rows.push({ label: label, segs: segs }); };
    push(chart.bodies[0].name, rowReading(chart, chart.bodies[0], lib));
    push(chart.bodies[1].name, rowReading(chart, chart.bodies[1], lib));
    push('Ascendant', rowReading(chart, { axis: 'asc', lon: chart.asc }, lib));
    for (var i = 2; i < chart.bodies.length; i++) push(chart.bodies[i].name, rowReading(chart, chart.bodies[i], lib));
    push('Midheaven', rowReading(chart, { axis: 'mc', lon: chart.mc }, lib));
    return rows;
  }
  /* ---- one line for the hero.
     The sharpest sentence the library already holds for this chart. Every
     module opens by teaching its term and saying where the body sits; the
     sentence after that is the claim, and the claim is what this takes. Rising
     first, because it is the most particular; then the Sun, which is all a
     chart with no birth time honestly has; then the Moon and the blend.
     Nothing is composed and nothing is written for the purpose. A sentence
     carrying a merge field, defining a term, shorter than six words (the voice
     uses fragments) or longer than twenty-two, or leaning on the sentence
     before it, is passed over. If none survives this returns '' and the page
     shows nothing rather than something half-written. */
  var HOOK_MIN = 6, HOOK_MAX = 22;
  var HOOK_DEFINES = /^(the|your)\s+(sun|moon|rising sign)\b|is the sign that|of the twelve signs|is the (first|second|third|fourth|fifth|sixth|seventh|eighth|ninth|tenth|eleventh|twelfth|last) sign|\bin a chart\b|\bis what you (are|need)\b/i;
  // a sentence that opens on a determiner is a noun phrase in a run ('The blank
   // page. The new job.'), and one that opens on a pronoun or a conjunction is
   // carrying the sentence before it; neither can stand alone
  var HOOK_BACKREF = /^(but|and|so|then|that|it|they|this|those|these|yours|here|there|either|instead|nor|or|both|the|a|an)\b/i;
  // it has to be about a person, or it is a definition or an instruction
  var HOOK_PERSON = /\b(you|your|yours|people|anyone|someone|nobody|no one|others|everyone)\b/i;
  function hookFrom(raw) {
    if (typeof raw !== 'string') return '';
    var parts = raw.replace(/\s+/g, ' ').match(/[^.!?]+[.!?]/g) || [];
    for (var i = 0; i < parts.length; i++) {
      var s = parts[i].trim();
      if (s.indexOf('{') >= 0 || s.indexOf('[') >= 0) continue;          // a merge field, or an entry not yet written
      var words = s.split(' ').length;
      if (words < HOOK_MIN || words > HOOK_MAX) continue;
      if (HOOK_DEFINES.test(s) || HOOK_BACKREF.test(s)) continue;
      if (!HOOK_PERSON.test(s)) continue;
      return s;
    }
    return '';
  }
  /* Every sentence in one entry that could stand alone, not just the first.
     Same gate as hookFrom — whole sentences, no merge field, no unwritten
     entry, no back-reference, and it has to be about a person — so a caller can
     never be handed a fragment or a placeholder. */
  function hookAll(raw) {
    var out = [];
    if (typeof raw !== 'string') return out;
    var parts = raw.replace(/\s+/g, ' ').match(/[^.!?]+[.!?]/g) || [];
    for (var i = 0; i < parts.length; i++) {
      var s = parts[i].trim();
      if (s.indexOf('{') >= 0 || s.indexOf('[') >= 0) continue;
      var words = s.split(' ').length;
      if (words < HOOK_MIN || words > HOOK_MAX) continue;
      if (HOOK_DEFINES.test(s) || HOOK_BACKREF.test(s)) continue;
      if (!HOOK_PERSON.test(s)) continue;
      if (out.indexOf(s) < 0) out.push(s);
    }
    return out;
  }

  /* The lines a chart can be quoted by, best first: the rising sign speaks
     about how a person lands on others, then the Sun, then the Moon, then the
     blend. Drawn from the same library entries the reading is built from — the
     poster never says anything the page would not. `fits` is the caller's own
     test (the print measures pixels, not characters); lines that fail it are
     dropped rather than shortened, because half a sentence is not a quote. */
  function quoteLines(chart, lib, fits) {
    if (!chart || !chart.bodies) return [];
    var facts = FACTS.factsFor(chart, lib);
    var paths = [];
    if (chart.anglesKnown && !chart.solarHouses && facts.rising) paths.push('rising.' + facts.rising + '.page');
    paths.push('sun.sign.' + FACTS.signOf(facts.sun.lon) + '.page');
    if (chart.moonKnown !== false) {
      paths.push('moon.sign.' + FACTS.signOf(facts.moon.lon) + '.page');
      paths.push('blend.' + facts.blendKey + '.page');
    }
    var out = [];
    for (var i = 0; i < paths.length; i++) {
      var raw = paths[i].split('.').reduce(function (o, k) { return o && o[k] != null ? o[k] : null; }, lib);
      var lines = hookAll(raw);
      for (var j = 0; j < lines.length; j++) {
        if (typeof fits === 'function' && !fits(lines[j])) continue;
        if (out.indexOf(lines[j]) < 0) out.push(lines[j]);
      }
    }
    return out;
  }

  function hookLine(chart, lib) {
    if (!chart || !chart.bodies) return '';
    var facts = FACTS.factsFor(chart, lib);
    var paths = [];
    if (chart.anglesKnown && !chart.solarHouses && facts.rising) paths.push('rising.' + facts.rising + '.page');
    paths.push('sun.sign.' + FACTS.signOf(facts.sun.lon) + '.page');
    if (chart.moonKnown !== false) {
      paths.push('moon.sign.' + FACTS.signOf(facts.moon.lon) + '.page');
      paths.push('blend.' + facts.blendKey + '.page');
    }
    for (var i = 0; i < paths.length; i++) {
      var raw = paths[i].split('.').reduce(function (o, k) { return o && o[k] != null ? o[k] : null; }, lib);
      var line = hookFrom(raw);
      if (line) return line;
    }
    return '';
  }

  var asText = function (paras) { return paras.map(function (segs) { return segs.map(function (s) { return s.text; }).join(' '); }).join('\n\n'); };
  var forMail = function (paras) { return paras.map(function (segs) { return { label: '', text: segs.map(function (s) { return s.text; }).join(' ') }; }); };
  var placeholders = function (paras) { var out = []; paras.forEach(function (segs) { segs.forEach(function (s) { if (s.ph) out.push(s.text); }); }); return out; };

  window.OrreryCompose = { compose: compose, hookLine: hookLine, quoteLines: quoteLines, sectionReading: sectionReading, SECTION_KEYS: SECTION_KEYS, emailOne: emailOne, emailTwo: emailTwo, emailTwoSections: emailTwoSections, love: love, chosenPattern: chosenPattern, rowReading: rowReading, allRows: allRows, asText: asText, forMail: forMail, placeholders: placeholders, VERSION: 3 };
})();
